'use client';

import { cva, type VariantProps } from 'class-variance-authority';
import cn from 'clsx';
import { HTMLAttributes } from 'react';

import { TabItem } from '../../tabItem/TabItem';

const segmentTabsVariants = cva('grid w-full auto-cols-fr grid-flow-col bg-neutral-background-low', {
  variants: {
    size: {
      xsmall: 'p-tiny-medium rounded-bzc-xsmall',
      medium: 'p-tiny-medium rounded-bzc-small'
    }
  },
  defaultVariants: {
    size: 'medium'
  }
});

export interface TabsProps extends HTMLAttributes<HTMLDivElement>, VariantProps<typeof segmentTabsVariants> {
  tabsItem: string[];
  selectedIndex: number;
  selectTab: (index: number) => void;
}

export const SegmentTabs = ({ size = 'medium', tabsItem, selectedIndex, selectTab }: TabsProps) => {
  if (tabsItem.length === 0) {
    console.error('tabsItem must be at least 1 tab');
    return null;
  }

  return (
    <div className={cn(segmentTabsVariants({ size }))}>
      <TabItem
        variant={'segment'}
        size={size}
        label={''}
        className={'col-start-1 row-start-1 bg-white transition-all duration-300 will-change-transform'}
        style={{ transform: `translate3d(${selectedIndex * 100}%, 0, 0)` }}
        selected={true}
      />
      {tabsItem.map((label, index) => (
        <TabItem
          variant={'segment'}
          size={size}
          className={cn('!shadow-none z-10', {
            'col-start-1 row-start-1': index === 0
          })}
          label={label}
          key={index}
          selected={selectedIndex === index}
          onClick={() => {
            selectTab(index);
          }}
        />
      ))}
    </div>
  );
};
